var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-container"},[_c(_setup.PageHeader),_c('div',{staticClass:"page-viewer"},[_c('router-view')],1),_c(_setup.PageFooter)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }